module.exports = __webpack_public_path__ + "img/menuico_06.803dfd50.svg";